/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lessons_UnmatchedInputs */

const en_lessons_unmatched = /** @type {(inputs: Lessons_UnmatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calendar events with no matching student.`)
};

const he_lessons_unmatched = /** @type {(inputs: Lessons_UnmatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} אירועי יומן ללא תלמיד תואם.`)
};

/**
* | output |
* | --- |
* | "{count} calendar events with no matching student." |
*
* @param {Lessons_UnmatchedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_unmatched = /** @type {((inputs: Lessons_UnmatchedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_UnmatchedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_unmatched(inputs)
	return he_lessons_unmatched(inputs)
});